import { lightBlue, lightGreen } from 'material-ui/colors'
import createMuiTheme from 'material-ui/styles/createMuiTheme'
import createPalette, { Palette } from 'material-ui/styles/createPalette'
import createTypography, { TypographyStyle } from 'material-ui/styles/createTypography'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { browserHistory, Route, Router } from 'react-router'
import './index.css'
import registerServiceWorker from './registerServiceWorker'
import { MainIndex } from './views/index/MainIndex'
import { AvantStory } from './views/stories/AvantStory'
import { XprizeStory } from './views/stories/XprizeStory'
import { RandomLengthsStory } from './views/stories/RandomLengthsStory'
import { ContactPage } from './views/components/ContactPage'

const palette = createPalette({
    primary: lightBlue,
    accent: lightGreen
} as Partial<Palette>)

const display1: TypographyStyle = {
    color: '#404040',
    fontFamily: '"Saira Semi Condensed", sans-serif'
} as TypographyStyle

const title: TypographyStyle = {
    color: '#404040',
    fontFamily: '"Saira Semi Condensed", sans-serif'
} as TypographyStyle

const caption: TypographyStyle = {
    color: '#9B9B9B',
    fontSize: 16,
    fontFamily: '"Saira Semi Condensed", sans-serif'
} as TypographyStyle

const display2: TypographyStyle = {
    color: '#404040',
    fontFamily: '"Manuale", sans-serif'
} as TypographyStyle

const display3: TypographyStyle = {
    color: '#404040',
    fontFamily: '"Manuale", sans-serif'
} as TypographyStyle

const display4: TypographyStyle = {
    color: '#404040',
    fontWeight: 700,
    fontSize: 72,
    fontFamily: '"Saira Semi Condensed", sans-serif'
} as TypographyStyle

const typography = createTypography(palette, {
    fontFamily: '"Manuale", sans-serif',
    display4,
    display3,
    display2,
    display1,
    title,
    caption
})

const theme = createMuiTheme({typography, palette})

ReactDOM.render(
    <MuiThemeProvider theme={theme}>
        <Router history={browserHistory}>
            <Route path='/' component={MainIndex}/>
            <Route path='/avant' component={AvantStory}/>
            <Route path='/xprize' component={XprizeStory}/>
            <Route path='/contact' component={ContactPage}/>
            <Route path='/random-lengths' component={RandomLengthsStory}/>
        </Router>
    </MuiThemeProvider>
    ,
    document.getElementById('root') as HTMLElement
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.tsx